/**
 * Banner Component - Template
 * ============================
 *
 * Template HTML del componente Banner.
 */

/**
 * Template principal del Banner (horizontal)
 */
export const BANNER_TEMPLATE: string = `
<div
  ng-if="$ctrl.isVisible"
  class="ec-banner"
  ng-class="$ctrl.getContainerClasses()"
  ng-click="$ctrl.handleClick($event)"
  role="banner"
  tabindex="0"
>
  <!-- ===== ICONO ===== -->
  <div
    ng-if="$ctrl.showIcon !== false"
    ng-class="$ctrl.getIconWrapperClasses()"
  >
    <div
      ng-class="$ctrl.getIconClasses()"
      ng-bind-html="$ctrl.trustedIconHtml"
    ></div>
  </div>

  <!-- ===== CONTENIDO ===== -->
  <div class="ec-flex-1 ec-min-w-0">
    <!-- MODO COMPOUND (composición vía ecBannerTitle/ecBannerText/ecBannerActions) -->
    <div ng-if="$ctrl.isCompound" ng-transclude></div>

    <!-- MODO LEGACY (bindings title/description · comportamiento histórico) -->
    <div ng-if="!$ctrl.isCompound">
      <!-- Título -->
      <h4
        ng-if="$ctrl.title"
        ng-class="$ctrl.getTitleClasses()"
        class="ec-leading-tight"
      >
        {{ $ctrl.title }}
      </h4>

      <!-- Descripción -->
      <p
        ng-if="$ctrl.description"
        ng-class="$ctrl.getDescriptionClasses()"
        class="ec-leading-relaxed"
      >
        {{ $ctrl.description }}
      </p>

      <!-- Contenido transcluido -->
      <div ng-transclude class="ec-mt-2"></div>
    </div>
  </div>

  <!-- ===== BOTÓN CTA ===== -->
  <button
    ng-if="$ctrl.hasButton"
    type="button"
    ng-class="$ctrl.getButtonClasses()"
    ng-click="$ctrl.handleButtonClick($event)"
  >
    {{ $ctrl.buttonText }}
  </button>

  <!-- ===== BOTÓN CERRAR ===== -->
  <button
    ng-if="$ctrl.dismissible"
    type="button"
    ng-class="$ctrl.getDismissClasses()"
    ng-click="$ctrl.handleDismiss($event)"
    aria-label="Cerrar"
  >
    <svg class="ec-w-4 ec-h-4" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    </svg>
  </button>
</div>
`;

/**
 * Template vertical (icono arriba)
 */
export const BANNER_VERTICAL_TEMPLATE: string = `
<div
  ng-if="$ctrl.isVisible"
  class="ec-banner-vertical"
  ng-class="$ctrl.getContainerClasses()"
  ng-click="$ctrl.handleClick($event)"
  role="banner"
  tabindex="0"
>
  <!-- ===== BOTÓN CERRAR (absoluto) ===== -->
  <button
    ng-if="$ctrl.dismissible"
    type="button"
    class="ec-absolute ec-top-2 ec-right-2"
    ng-class="$ctrl.getDismissClasses()"
    ng-click="$ctrl.handleDismiss($event)"
    aria-label="Cerrar"
  >
    <svg class="ec-w-4 ec-h-4" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    </svg>
  </button>

  <!-- ===== ICONO ===== -->
  <div
    ng-if="$ctrl.showIcon !== false"
    ng-class="$ctrl.getIconWrapperClasses()"
  >
    <div
      ng-class="$ctrl.getIconClasses()"
      ng-bind-html="$ctrl.trustedIconHtml"
    ></div>
  </div>

  <!-- ===== CONTENIDO ===== -->
  <div class="ec-w-full">
    <!-- MODO COMPOUND (composición vía ecBannerTitle/ecBannerText/ecBannerActions) -->
    <div ng-if="$ctrl.isCompound" ng-transclude></div>

    <!-- MODO LEGACY (bindings title/description · comportamiento histórico) -->
    <div ng-if="!$ctrl.isCompound">
      <!-- Título -->
      <h4
        ng-if="$ctrl.title"
        ng-class="$ctrl.getTitleClasses()"
        class="ec-leading-tight"
      >
        {{ $ctrl.title }}
      </h4>

      <!-- Descripción -->
      <p
        ng-if="$ctrl.description"
        ng-class="$ctrl.getDescriptionClasses()"
        class="ec-leading-relaxed"
      >
        {{ $ctrl.description }}
      </p>

      <!-- Contenido transcluido -->
      <div ng-transclude class="ec-mt-2"></div>
    </div>
  </div>

  <!-- ===== BOTÓN CTA ===== -->
  <button
    ng-if="$ctrl.hasButton"
    type="button"
    ng-class="$ctrl.getButtonClasses()"
    ng-click="$ctrl.handleButtonClick($event)"
    class="ec-mt-4"
  >
    {{ $ctrl.buttonText }}
  </button>
</div>
`;

/**
 * Template compacto (solo icono y texto, sin botón)
 */
export const BANNER_COMPACT_TEMPLATE: string = `
<div
  ng-if="$ctrl.isVisible"
  class="ec-banner-compact ec-inline-flex ec-items-center ec-rounded-full ec-cursor-pointer ec-transition-colors"
  ng-class="[$ctrl.getVariantClasses().container, $ctrl.getSizeClasses().gap]"
  ng-click="$ctrl.handleClick($event)"
  style="padding: 6px 12px 6px 6px;"
  role="banner"
>
  <!-- ===== ICONO ===== -->
  <div
    ng-if="$ctrl.showIcon !== false"
    class="ec-flex-shrink-0 ec-rounded-full ec-flex ec-items-center ec-justify-center"
    ng-class="[$ctrl.getSizeClasses().iconWrapper, $ctrl.getVariantClasses().iconBg]"
    style="width: 28px; height: 28px;"
  >
    <div
      class="ec-w-4 ec-h-4"
      ng-class="$ctrl.getVariantClasses().iconColor"
      ng-bind-html="$ctrl.trustedIconHtml"
    ></div>
  </div>

  <!-- ===== TEXTO ===== -->
  <span
    ng-class="[$ctrl.getSizeClasses().title, $ctrl.getVariantClasses().title]"
  >
    {{ $ctrl.title }}
  </span>

  <!-- ===== CERRAR ===== -->
  <button
    ng-if="$ctrl.dismissible"
    type="button"
    class="ec-ml-2 ec-p-1 ec-rounded-full ec-transition-colors hover:ec-bg-black/10"
    ng-class="$ctrl.getVariantClasses().iconColor"
    ng-click="$ctrl.handleDismiss($event)"
    aria-label="Cerrar"
  >
    <svg class="ec-w-3 ec-h-3" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    </svg>
  </button>
</div>
`;

// ============================================================================
// TEMPLATES DE HIJOS (Compound Components)
// ============================================================================

/**
 * ecBannerTitle — título del modo compound.
 * `ec-leading-tight` queda fijo (interlineado); color y tamaño se resuelven
 * vía ng-class con las clases del padre (ecBanner/ecBannerVertical, require
 * dual opcional en BannerTitleController). Sin padre (uso standalone) cae a
 * un peso de fuente estático razonable — ver BannerTitleController.getClasses().
 */
export const BANNER_TITLE_TEMPLATE = `<h4 class="ec-leading-tight" ng-class="$ctrl.getClasses()" ng-transclude></h4>`;

/**
 * ecBannerText — texto del modo compound (equivalente al binding `description`).
 * `ec-leading-relaxed` queda fijo; color y tamaño se resuelven vía ng-class
 * con las clases del padre (mismo require dual opcional que ecBannerTitle).
 */
export const BANNER_TEXT_TEMPLATE = `<p class="ec-leading-relaxed" ng-class="$ctrl.getClasses()" ng-transclude></p>`;

/**
 * ecBannerActions — contenedor de acciones del modo compound
 */
export const BANNER_ACTIONS_TEMPLATE = `<div class="ec-flex ec-items-center ec-gap-2 ec-mt-2" ng-transclude></div>`;

export default BANNER_TEMPLATE;
